import React, { useMemo } from 'react';
import TopNav from '../TopNav';
import { useOwnerDetails } from '../../api/owners';
import MasqueradingBanner from '../Masquerading/MasqueradingBanner';
import './OverviewLayout.scss';
import Footer from 'components/Dashboard/Footer';
import { useLocation } from 'react-router';
import { RequestBanner } from 'components/RequestBanner';
import { useSignedUser } from 'api/auth';
import { URLS } from 'components/Routes/urls';

const OverviewLayout = ({ className, children }: { children; className?: string }) => {
  const { data: user } = useSignedUser();
  const isMasquerading = useMemo(() => user?.is_masqueraded, [user]);

  const { data: owner, isLoading } = useOwnerDetails(user?.owner_id);
  const location = useLocation();
  const showRequestsBanner = useMemo(
    () => location.pathname !== URLS.REQUESTS && owner.hasRequests,
    [location, owner],
  );

  return (
    <>
      {isMasquerading && !isLoading && <MasqueradingBanner identifier={user.email} />}
      <TopNav />
      <div className={`Overview_content${isMasquerading ? ' masquerading' : ''} ${className}`}>
        <div className="Overview_supportText">
          <span className="supportTextLabel">Questions? Text us </span>
          <span className="supportTextNumber">+1 (442) 269-4808</span>
          <span className="supportTextHours">9-5 EST</span>
        </div>

        {showRequestsBanner && (
          <div className="Overview_banner">
            <RequestBanner visible={showRequestsBanner} />
          </div>
        )}
        {children}
      </div>
      <Footer />
    </>
  );
};

export default OverviewLayout;
